export default class AddGroupChildrenItem {
  constructor(groupId) {
    this.ParentGroupId = groupId;
    this.ChildGroupIds = [];
  }
}
